/*! Polyfill for ES6 Number.isInteger */
Number.isInteger=Number.isInteger||function(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e};